const DEFAULT_SUPER_ADMIN_IDENTIFIERS = [
  "dubsthecreator",
];

const PRIVATE_LAUNCH_PUBLIC_PATH_PREFIXES = [
  "/forgot-password",
  "/forgot-username",
  "/reset-password",
  "/wallet",
  "/token",
];

const normalizeIdentifier = (value) => String(value || "").trim().toLowerCase();

export const isPrivateLaunchModeEnabled = () => {
  const configuredValue = normalizeIdentifier(process.env.REACT_APP_PRIVATE_LAUNCH_MODE);
  return configuredValue !== "false" && configuredValue !== "off" && configuredValue !== "0";
};

export const getPrivateLaunchSuperAdminIdentifiers = () => {
  return DEFAULT_SUPER_ADMIN_IDENTIFIERS.map(normalizeIdentifier);
};

export const isCanonicalSuperAdmin = (user) => {
  if (!user || typeof user !== "object") {
    return false;
  }

  const allowedIdentifiers = getPrivateLaunchSuperAdminIdentifiers();
  const userIdentifiers = [user.email, user.handle, user.uniqueId, user._id, user.id]
    .map(normalizeIdentifier)
    .filter(Boolean);

  return userIdentifiers.some((identifier) => allowedIdentifiers.includes(identifier));
};

export const isPrivateLaunchPublicPath = (pathname = "", search = "") => {
  const normalizedPath = String(pathname || "/").toLowerCase();

  if (normalizedPath === "/home-page") {
    const searchParams = new URLSearchParams(String(search || ""));
    const overlay = String(searchParams.get("overlay") || "").trim().toLowerCase();

    if (overlay === "wallet") {
      return true;
    }
  }

  return PRIVATE_LAUNCH_PUBLIC_PATH_PREFIXES.some(
    (publicPath) => normalizedPath === publicPath || normalizedPath.startsWith(`${publicPath}/`)
  );
};

export const isPrivateLaunchSuperAdmin = (user) => {
  if (!isPrivateLaunchModeEnabled()) {
    return true;
  }

  return isCanonicalSuperAdmin(user);
};